import React from "react";
import Box from "@mui/material/Box";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";
import { DateRange } from "../types";

type RangeDayProps = Omit<PickersDayProps, "day"> & {
  day: Dayjs;
  range: DateRange;
};

export function RangeDay({
  day,
  outsideCurrentMonth,
  range,
  ...other
}: RangeDayProps) {
  const [start, end] = range;
  const isStart = !!start && day.isSame(start, "day");
  const isEnd = !!end && day.isSame(end, "day");
  const inRange =
    !!start && !!end && day.isAfter(start, "day") && day.isBefore(end, "day");
  const showHighlight = !outsideCurrentMonth && (isStart || isEnd);

  return (
    <Box sx={{ position: "relative" }}>
      {inRange && !outsideCurrentMonth && (
        <Box sx={{ position: "absolute", inset: 0, bgcolor: "action.hover" }} />
      )}
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        disableMargin
        sx={
          showHighlight
            ? {
                zIndex: 1,
                borderRadius: 2.5,
                bgcolor: "primary.main",
                color: "primary.contrastText",
                "&:hover": { bgcolor: "primary.dark" },
                "&:focus": {
                  bgcolor: "primary.dark",
                  color: "primary.contrastText",
                },
              }
            : { zIndex: 1, borderRadius: 2.5 }
        }
      />
    </Box>
  );
}
